
define(
  'MachineFit',
  [
    'MachineFit.View'
  ],
  function (
    MachineFitView
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var pdp = container.getComponent('PDP');

        if (pdp) {
          pdp.addChildViews(
            pdp.PDP_FULL_VIEW,
            {
              MachineFit: {
                MachineFitView: {
                  childViewIndex: 1,
                  childViewConstructor: function () {
                    var pdpItemInfo = pdp.getItemInfo();
                    var item = pdpItemInfo.item;
                    return new MachineFitView({ application: container, item: item });
                  }
                }
              }
            }
          );
        }
      }
    };
  }
);
